import {
  UserRsvpResponse,
  UserSummary,
  UserSummaryRsvpResponse,
} from 'redux/services/types/singleActivity';

export const activityTypes = {
  game_consolation: 'Game',
  game_league: 'Game',
  game_friendly: 'Game',
  game_pool_play: 'Game',
  game_playoff: 'Game',
  game_scrimmage: 'Game',
  game_season: 'Game',
  game_tournament: 'Game',
  game_travel: 'Game',
  game_final: 'Game',
  event_practice: 'Practice',
  event_lesson: 'Lesson',
  event_training: 'Training',
  event_meeting: 'Meeting',
  event_tournament: 'Tournament',
  event_league: 'League',
  event_camp: 'Camp',
  event_class: 'Class',
  event_other: 'Other',
};

export const getInitials = (firstName: string, lastName: string) => {
  return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`;
};

export const removeDuplicates = (users: UserSummary[]) => {
  const deDupedArray = users.reduce((uniqueArray, item) => {
    if (!uniqueArray.some((i) => i.userId === item.userId)) {
      uniqueArray.push(item);
    }
    return uniqueArray;
  }, [] as UserSummary[]);

  return deDupedArray;
};

export const transformRsvpResponse = (
  data: UserRsvpResponse
): UserSummaryRsvpResponse => {
  switch (data) {
    case 'yes':
      return 'going';
    case 'no':
      return 'not_going';
    case 'maybe':
      return 'maybe';
    default:
      return 'no_response';
  }
};
